export default __webpack_public_path__ + "static/media/tracking_logo.64c2e46e.svg";